import React from 'react';
import { CenteredPage } from '../pages';
import { Spinner, SpinnerProps } from '../atoms';
import Flex from './Flex';

export interface LoadingStateProps extends React.HTMLAttributes<HTMLDivElement> {
  fullPage?: boolean;
  label?: string;
  spinnerVariant?: SpinnerProps['variant'];
  spinnerSize?: SpinnerProps['size'];
}

const LoadingState: React.FC<LoadingStateProps> = ({
  fullPage = false,
  label = 'Chargement...',
  spinnerVariant = 'primary',
  spinnerSize,
  className,
  style,
  ...props
}) => {
  const spinner = (
    <Spinner
      label={label}
      variant={spinnerVariant}
      size={spinnerSize}
    />
  );

  if (fullPage) {
    return (
      <CenteredPage
        className={className}
        style={{ height: '100vh', ...style }}
        {...props}
      >
        {spinner}
      </CenteredPage>
    );
  }

  return (
    <Flex
      justify="center"
      align="center"
      className={className}
      style={style}
      {...props}
    >
      {spinner}
    </Flex>
  );
};

export default LoadingState;
